var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 452,
    height: 217,
    viewBox: "0 0 452 217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "7231ka193a",
    d: "M0.301 78.283H1441.301V319.283H0.301z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9ln9tbp1ad",
    d: "M0 0H107V123.241H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cvy6emq36f",
    d: "M0.213 0.979H106.213V122.979H0.213z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "5sphjo9pog",
    d: "M17.646 52.408s.34-.793.51-1.416c.17-.623 2.943-44.135 3-44.815.057-.68.963-3.853.963-3.853V.606H.605v1.662s.906 3.172.963 3.853c.056.68 2.83 44.19 3 44.814.17.623.51 1.416.51 1.416s4.812.17 12.794.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "syoiqq67ki",
    d: "M3.077 19.198L19.797 19.198 19.044 31.236 3.832 31.236z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4vtsn8kfjj",
    d: "M-1.917 60.008L20.807 60.008 20.807 0 -1.917 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6hhc4dn1zm",
    d: "M0 0H107V123.241H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bvsizldi5o",
    d: "M0 0H107V123.241H0z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "00hbmy7cdc",
    width: "108.4%",
    height: "107.3%",
    x: "-4.2%",
    y: "-3.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "6l1kkrdn8e",
    width: "108.5%",
    height: "107.4%",
    x: "-4.2%",
    y: "-3.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "klwuwepkfl",
    width: "108.4%",
    height: "107.3%",
    x: "-4.2%",
    y: "-3.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "5dl3w3dfrn",
    width: "108.4%",
    height: "107.3%",
    x: "-4.2%",
    y: "-3.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-503 -223) translate(0 145)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ll65fnfm1b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7231ka193a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ll65fnfm1b)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-18 471.496 -2291.459)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#00hbmy7cdc)",
    xlinkHref: "#9ln9tbp1ad"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#9ln9tbp1ad"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FDF1EB",
    d: "M9.554 9.554H96.492V87.893H9.554z",
    transform: "rotate(-18 471.496 -2291.459)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAC9",
    d: "M4.89 14.808L34.708 14.664 32.633 38.062 6.763 38.062z",
    transform: "rotate(-18 471.496 -2291.459) translate(33.438 23.884)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.18 38.062h25.453c-.288 3.853-.431 5.969-.431 6.348 0 .57-2.303 5.449-2.303 5.449h-19.52c-1.235-.5-2.146-2.023-2.734-4.567-.588-2.545-.743-4.955-.466-7.23z",
    transform: "rotate(-18 471.496 -2291.459) translate(33.438 23.884)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.38,
    d: "M4.128 6.882s3.09 31.04 3.09 34.69c0 3.652 1.92 8.287 3.16 8.287h14.677",
    transform: "rotate(-18 471.496 -2291.459) translate(33.438 23.884)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.38,
    d: "M35.519 6.882s-3.09 31.04-3.09 34.69c0 3.652-1.92 8.287-3.16 8.287H14.592M6.763 38.062L32.633 38.062",
    transform: "rotate(-18 471.496 -2291.459) translate(33.438 23.884)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ll65fnfm1b)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(9 -50.013 4373.69)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#6l1kkrdn8e)",
    xlinkHref: "#cvy6emq36f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#cvy6emq36f"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FDF1EB",
    d: "M9.167 9.982H95.167V87.982H9.167z",
    transform: "rotate(9 -50.013 4373.69)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(9 -50.013 4373.69) translate(41.601 18.79)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rt9n4htr6h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5sphjo9pog"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "#231F20",
    strokeWidth: 1.38,
    xlinkHref: "#5sphjo9pog"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#rt9n4htr6h)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#syoiqq67ki"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFC4C7",
    xlinkHref: "#syoiqq67ki"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.38,
    d: "M1.639 5.266L21.008 5.342",
    mask: "url(#rt9n4htr6h)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "kashbff1dk",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4vtsn8kfjj"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.38,
    d: "M5.078 59.402L17.536 59.402 17.536 52.295 5.078 52.295zM2.547 19.198L20.327 19.198M3.077 31.236L19.116 31.236",
    mask: "url(#kashbff1dk)"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ll65fnfm1b)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-14 755.817 -1997.466)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#klwuwepkfl)",
    xlinkHref: "#6hhc4dn1zm"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#6hhc4dn1zm"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FDF1EB",
    d: "M9.554 9.554H96.492V87.893H9.554z",
    transform: "rotate(-14 755.817 -1997.466)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#231F20",
    strokeWidth: 1.38
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC4C7",
    d: "M14.537 9.303L17.226 9.564 17.226 24.488 2.49 24.488 2.49 9.564 4.049 9.303",
    transform: "rotate(-14 755.817 -1997.466) translate(42.991 16.241)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.82 27.395v-2.997H.895v2.997l-.896.13v32.586c0 4.838 19.716 4.289 19.716 0V27.525l-.897-.13z",
    transform: "rotate(-14 755.817 -1997.466) translate(42.991 16.241) translate(0 .09)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.863 27.395L18.852 27.395",
    transform: "rotate(-14 755.817 -1997.466) translate(42.991 16.241) translate(0 .09)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF1EA",
    d: "M4.05 2.891L11.417.545h3.983l.265 1.434s-.863.391-1.062 1.368c-.2.978-.067 5.866-.067 5.866s-4.555 1.825-10.488 0V2.891z",
    transform: "rotate(-14 755.817 -1997.466) translate(42.991 16.241) translate(0 .09)"
  })))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ll65fnfm1b)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(9 -554.98 5454.449)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#5dl3w3dfrn)",
    xlinkHref: "#bvsizldi5o"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#bvsizldi5o"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FDF1EB",
    d: "M10.509 9.554H97.447V87.893H10.509z",
    transform: "rotate(9 -554.98 5454.449)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#373535",
    strokeWidth: 1.38,
    d: "M49.644 54.073H3.636c0-1.32-2.197-9.817-3.37-14.945C-.76 34.639 1.469 27.59 2.04 26.118c.09-.23.17-.465.232-.704C4.387 17.242 4.955 2.498 4.955 2.498S5.04 2.49 9.877 0c0 0 15.385 18.169 33.553 0l4.835 2.491s.569 14.744 2.682 22.917c.062.239.142.473.232.704.572 1.471 2.8 8.52 1.775 13.01-1.173 5.127-3.37 13.625-3.37 14.944H3.577",
    transform: "rotate(9 -554.98 5454.449) translate(26.75 21.973)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#373535",
    strokeWidth: 1.38,
    d: "M3.007 50.128L50.212 50.128M9.063 5.792s9.58 2.609 9.58 20.512c0 1.34-.826 2.507-2.11 3.834",
    transform: "rotate(9 -554.98 5454.449) translate(26.75 21.973)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF1EA",
    stroke: "#373535",
    strokeWidth: 1.38,
    d: "M9.063 5.792s9.58 2.609 9.58 20.512c0 1.34-.826 2.507-2.11 3.834-4.154-3.319-6.539-7.376-7.156-12.173-.616-4.797-.72-8.855-.314-12.173zM43.973 5.792s-9.58 2.609-9.58 20.512c0 1.34.826 2.507 2.11 3.834 4.154-3.319 6.54-7.376 7.156-12.173.616-4.797.72-8.855.314-12.173z",
    transform: "rotate(9 -554.98 5454.449) translate(26.75 21.973)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#373535",
    strokeWidth: 1.38,
    d: "M44.13 5.792S34.55 8.4 34.55 26.304c0 1.34.826 2.507 2.11 3.834",
    transform: "rotate(9 -554.98 5454.449) translate(26.75 21.973)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#373535",
    strokeWidth: 1.38,
    d: "M9.877 0S2.658 32.918 26.61 32.918C50.56 32.918 43.43 0 43.43 0",
    transform: "rotate(9 -554.98 5454.449) translate(26.75 21.973)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC1C6",
    d: "M3.821 50.634L49.679 50.634 49.157 53.5 4.524 53.5z",
    transform: "rotate(9 -554.98 5454.449) translate(26.75 21.973)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeHeader);
export default __webpack_public_path__ + "static/media/welcome-header.bc8ad881633a0c541bdce4a432335828.svg";
export { ForwardRef as ReactComponent };